import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { jwtDecode } from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';

import { Client, FileResponse, PermissionsEnum, UserDataOut } from '../../../../api/api-reference';
import { AuthService } from '../../../../services/auth.service';


@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule, AngularSvgIconModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  user: UserDataOut = new UserDataOut();
  public PermissionsEnum = PermissionsEnum;

  constructor(
    public authService: AuthService,
    private router: Router,
    private client: Client,
    public toastr: ToastrService,
  ) {}
  logoPath: string = ''; 
  deafultLogo = 'assets/sidebar/hes-logo-smaller.svg';

  ngOnInit() {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedPayload = jwtDecode(token) as {
        name: string;
        image: string;
        lastName: string;
      };
      this.user.firstName = decodedPayload.name;
      this.user.image = decodedPayload.image;


      this.client.getUtilityLogo().subscribe({
        next: (data) => {
          if (data.status === 204) {
            this.logoPath = this.deafultLogo;
            return;
          }
          this.logoPath = URL.createObjectURL(data.data);
        },
        error: (err) => {
          this.logoPath = this.deafultLogo;
        },
      });
    }
  }

  isActive(route: string): boolean {
    const currentRoute = this.router.url;
    return currentRoute.includes(route);
  }

  refreshPage() {
    location.reload(); //current URL address
  }
}
